import { useSetAtom } from 'jotai';
import { DragEvent, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { atomDragType } from '@/modules/AutomationModuleNew/atoms/flows';
import {
  AccordionNodes,
  DragAndDropNode,
} from '@/modules/AutomationModuleNew/components/AccordionNodes';
import { AccordionNodesType } from '@/modules/AutomationModuleNew/components/AccordionNodes/AccordionNodes';
import { NODE_TYPES_MAP, TRANSLATIONS } from '@/modules/AutomationModuleNew/constants/flows';
import { JourneyNodeTypes, NodeTypes } from '@/modules/AutomationModuleNew/types/flowsTypes';

const DragNodesContainer = () => {
  const { t } = useTranslation();
  const setDragType = useSetAtom(atomDragType);

  const handleDragStart = useCallback(
    (event: DragEvent<HTMLDivElement>, subType: JourneyNodeTypes) => {
      setDragType(subType);
      event.dataTransfer.effectAllowed = 'move';
    },
    [setDragType]
  );

  const generateChildren = useCallback(
    (nodeType: NodeTypes) => {
      return NODE_TYPES_MAP[nodeType].map((type, index, list) => (
        <DragAndDropNode
          key={type}
          iconType={nodeType}
          isDisabled={nodeType === 'trigger'}
          label={t(TRANSLATIONS.nodeTypes[type as keyof typeof TRANSLATIONS.nodeTypes])}
          noBorderButton={list.length - 1 === index}
          subType={type as JourneyNodeTypes}
          onDragStart={handleDragStart}
        />
      ));
    },
    [handleDragStart, t]
  );

  const dragNodes: Record<NodeTypes, AccordionNodesType> = {
    trigger: {
      label: t('trigger'),
      children: generateChildren('trigger'),
    },
    conditional: {
      label: t('action'),
      children: generateChildren('action'),
    },
    action: {
      label: t('condition'),
      children: generateChildren('conditional'),
    },
  };

  return (
    <div className="absolute z-50 ml-6 mt-6 h-auto w-[280px] overflow-hidden rounded-lg bg-emblue-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
      <AccordionNodes nodeTypes={dragNodes} />
    </div>
  );
};

export default memo(DragNodesContainer);
